import React, { Component } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Card, CardHeader, CardBody, Table, Input, FormGroup, Label, Row, Col } from 'reactstrap'
import { Bar } from 'react-chartjs-2'
import { RiseLoader } from 'react-spinners'

const QUERY = gql`
  query StatsWpsUsage {
    stats_wps_usage {
      wps_id wps_no welds_count welders_count total_mm_welded
      total_inspected total_failed defect_rate
    }
  }
`

class WpsUsage extends Component {
  constructor(props) {
    super(props)
    this.state = { sortBy: 'welds_count', sortDir: 'desc', filter: '' }
  }

  toggleSort(col) {
    this.setState(s => ({ sortBy: col, sortDir: s.sortBy === col && s.sortDir === 'desc' ? 'asc' : 'desc' }))
  }

  render() {
    return (
      <Query query={QUERY} fetchPolicy="network-only">
        {({ loading, error, data }) => (
          <div className="animated fadeIn">
            <Card>
              <CardHeader><strong><i className="fa fa-file-text-o mr-2" />WPS Usage Report</strong></CardHeader>
              <CardBody style={{ position: 'relative', minHeight: '200px' }}>
                {loading && <div className="spinner-item" id="loader-bg"><RiseLoader color="#20a8d8" loading={true} /></div>}
                {error && <div className="text-danger">Error: {error.message}</div>}
                {!loading && !error && data && data.stats_wps_usage && (() => {
                  const { sortBy, sortDir } = this.state
                  const wps = [...data.stats_wps_usage].sort((a, b) => {
                    const av = a[sortBy] || 0, bv = b[sortBy] || 0
                    return sortDir === 'desc' ? bv - av : av - bv
                  })

                  const top10 = [...data.stats_wps_usage].sort((a, b) => b.welds_count - a.welds_count).slice(0, 10)
                  const chartData = {
                    labels: top10.map(w => w.wps_no),
                    datasets: [
                      { label: 'Welds count', data: top10.map(w => w.welds_count), backgroundColor: 'rgba(54,162,235,0.7)', yAxisID: 'y1' },
                      { label: 'Defect rate %', data: top10.map(w => w.defect_rate), backgroundColor: 'rgba(255,99,132,0.7)', type: 'line', yAxisID: 'y2', fill: false }
                    ]
                  }

                  const thSort = (col, label) => (
                    <th style={{ cursor: 'pointer' }} onClick={() => this.toggleSort(col)}>
                      {label} {sortBy === col ? (sortDir === 'desc' ? '▼' : '▲') : ''}
                    </th>
                  )

                  const filtered = this.state.filter
                    ? wps.filter(w => w.wps_no.toLowerCase().includes(this.state.filter.toLowerCase()))
                    : wps

                  return (
                    <div>
                      <Row className="mb-4">
                        <Col md="12">
                          <h6>Top 10 WPS — usage vs defect rate</h6>
                          <Bar data={chartData} height={80} options={{
                            maintainAspectRatio: true,
                            scales: {
                              yAxes: [
                                { id: 'y1', position: 'left', ticks: { beginAtZero: true }, scaleLabel: { display: true, labelString: 'Welds count' } },
                                { id: 'y2', position: 'right', ticks: { beginAtZero: true }, scaleLabel: { display: true, labelString: 'Defect rate %' }, gridLines: { drawOnChartArea: false } }
                              ]
                            }
                          }} />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col sm={4}>
                          <Input type="text" placeholder="Filter WPS..." value={this.state.filter}
                            onChange={e => this.setState({ filter: e.target.value })} />
                        </Col>
                      </Row>

                      <Table bordered striped responsive size="sm">
                        <thead>
                          <tr>
                            <th style={{ cursor: 'pointer' }} onClick={() => this.toggleSort('wps_no')}>
                              WPS No {sortBy === 'wps_no' ? (sortDir === 'desc' ? '▼' : '▲') : '⇅'}
                            </th>
                            {thSort('welds_count', 'Welds')}
                            {thSort('welders_count', 'Welders')}
                            {thSort('total_mm_welded', 'Total mm')}
                            {thSort('total_inspected', 'Inspected mm')}
                            {thSort('total_failed', 'Failed mm')}
                            {thSort('defect_rate', 'Defect %')}
                          </tr>
                        </thead>
                        <tbody>
                          {filtered.map(w => (
                            <tr key={w.wps_id}>
                              <td><strong>{w.wps_no}</strong></td>
                              <td>{w.welds_count}</td>
                              <td>{w.welders_count}</td>
                              <td>{w.total_mm_welded.toLocaleString()}</td>
                              <td>{w.total_inspected.toLocaleString()}</td>
                              <td>{w.total_failed.toLocaleString()}</td>
                              <td style={{ color: w.defect_rate > 2 ? 'red' : w.defect_rate > 0 ? 'orange' : 'inherit' }}>
                                {w.defect_rate > 0 ? `${w.defect_rate}%` : '—'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="mt-3 p-3 border rounded bg-light" style={{ fontSize: '12px' }}>
                        <strong>How it's calculated:</strong>
                        <ul className="mb-0 mt-1 pl-3">
                          <li><strong>Welds</strong> — number of non-removed welds using this WPS</li>
                          <li><strong>Welders</strong> — number of distinct welders who used this WPS</li>
                          <li><strong>Total mm</strong> — sum of weld lengths using this WPS</li>
                          <li><strong>Inspected mm</strong> — sum of mm from completed inspection logs (all types) for welds using this WPS</li>
                          <li><strong>Failed mm</strong> — sum of mm from failed inspection logs for welds using this WPS</li>
                          <li><strong>Defect %</strong> — failed_mm / inspected_mm × 100</li>
                        </ul>
                      </div>
                    </div>
                  )
                })()}
              </CardBody>
            </Card>
          </div>
        )}
      </Query>
    )
  }
}

export default WpsUsage



// WEBPACK FOOTER //
// ./src/components/Report/WpsUsage.js